import { useMutation, type UseMutationResult } from '@tanstack/react-query';
import type { AxiosError, AxiosResponse } from 'axios';
import { useYwuApp } from '../../../contexts/ywu-app-context';
import { saveFileFromResponse } from '../../../utils/fileUtils';
import { downloadDocument } from '../../generated/client';

export const useDownloadDocument = (): UseMutationResult<AxiosResponse, AxiosError, number> => {
    const { activeLanguage } = useYwuApp();

    return useMutation({
        mutationFn: async (documentId) =>
            (await downloadDocument({ path: { id: documentId, docLanguage: activeLanguage }, responseType: 'arraybuffer' })) as AxiosResponse,
        onSuccess: (response) => {
            const axiosResponse = response as AxiosResponse<string>;
            saveFileFromResponse(axiosResponse);
        },
    });
};
